import React, { useEffect, useState, useContext } from "react";
import "./Profile.scss";
import ProfileImageModal from "../../Modals/ProfileImageModal";
import ProfileForm from "../../../hooks/editor/profileForm";
import { useTranslation } from "react-i18next";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import ResumeUseForm from "../../../hooks/editor/resumeUseForm";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import InputEditable from "../../../Components/ContentEditable/InputEditable";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";
import EditorInput from "../../Inputs/EditorInput";
import AddAdditionalFieldModal from "../../Modals/AddAdditionalFieldModal/AddAdditionalFieldModal";
function Profile({
  resumeHandler,
  resumeUpdate,
  sectionId,
  resumeFields,
  showHideElements,
  styles,
  settings,
  addResumeField,
  resumeAllFields,
  setResumeFields,
  resetImage,
  handleCustomDelete,
}) {
  const [t, i18n] = useTranslation("common");
  const [additionalModal, setAdditionalModal] = useState(false);

  const {
    fileUpload,
    modalShow,
    setModalShow,
    fileUploadError,
    setFileUploadError,
  } = ProfileForm(sectionId, resumeAllFields, setResumeFields, resumeUpdate);

  const { showPopup, arrayIndex } = useContext(ResumePopupContext);

  const onresumeHide = () => {
    setModalShow(false);
    setFileUploadError("");
  };

  const additionalFieldModal = () => {
    setAdditionalModal(!additionalModal);
  };

  const addResumeField1 = (ref, value, section) => {
    addResumeField(ref, value, section);
    if (sectionId != "profile") {
      setTimeout(() => {
        // changeFocusStyle(sectionId, value.length.toString(), "item");
        const element = document.getElementsByClassName("sectionFocusStyle");

        if (element && element[0]) {
          element[0].scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      }, 350);
    }
  };

  return (
    <>
      <AddAdditionalFieldModal
        show={additionalModal}
        handleAddAdditionalField={additionalFieldModal}
        sectionId={sectionId}
        resumeFields={resumeFields}
        addResumeField={addResumeField1}
      />
      <div className="card mb-4 section-card basic-scroll-profile">
        <div className="card-header d-flex justify-content-between align-items-center bg-white">
          <h4 className="card-title">Personal Details</h4>
        </div>

        <div className="card-body">
          {/* <div className="row">
            <div className="col-md-12 col-12 col-sm-12 mb-2">
              <label>Upload a square photo thats less than 2Mb</label>
              <div className="d-flex align-items-center mb-2">
                <div
                  onClick={() => setModalShow(true)}
                  className="d-flex align-items-center"
                >
                  {resumeFields &&
                  resumeFields.data &&
                  resumeFields.data[0] &&
                  resumeFields.data[0].photo != null &&
                  resumeFields &&
                  resumeFields.data &&
                  resumeFields.data[0] &&
                  resumeFields.data[0].photo != "" ? (
                    <img
                      src={
                        resumeFields &&
                        resumeFields.data &&
                        resumeFields.data[0] &&
                        resumeFields.data[0].photo
                      }
                      alt="profilephoto"
                      className="profilephoto mr-2"
                    />
                  ) : (
                    <img
                      src="/images/user.svg"
                      alt="profilephoto"
                      className="profilephoto mr-2"
                    />
                  )}
                  <div className="upload-btn-wrapper">
                    <ResumeButton
                      left
                      black
                      left_icon
                      src="/images/uparrow.svg"
                      alt="plus"
                      title={
                        resumeFields &&
                        resumeFields.data &&
                        resumeFields.data[0] &&
                        resumeFields.data[0].photo != ""
                          ? "Change Photo"
                          : "Upload Photo"
                      }
                    />
                  </div>
                </div>
                {resumeFields &&
                  resumeFields.data &&
                  resumeFields.data[0] &&
                  resumeFields.data[0].photo != "" && (
                    <span
                      style={{ cursor: "pointer" }}
                      className="resetimg"
                      onClick={() => resetImage(sectionId)}
                    >
                      Reset to Default
                    </span>
                  )}
              </div>
            </div>
          </div> */}
          <div className="row">
            {resumeFields && resumeFields.data && (
              <>
                {resumeFields &&
                  resumeFields.data &&
                  resumeFields.data[0] &&
                  resumeFields.data[0] && (
                    <div className="col-md-6 col-12 col-sm-12 mb-1">
                      <EditorInput
                        sectionId={sectionId}
                        label={
                          "name".split("_")[0] == "customField"
                            ? t(`profile.custom`)
                            : t(`profile.${"name"}`)
                        }
                        value={resumeFields.data[0]["name"]}
                        name={"name"}
                        delete={
                          "name".split("_")[0] == "customField"
                            ? true
                            : "name".split("_")[0] == "custom"
                            ? true
                            : false
                        }
                        autoComplete="off"
                        className={`form-control  ${sectionId}focus${0}`}
                        onChange={(e) =>
                          resumeHandler(e, 0, "basic", sectionId)
                        }
                        onBlur={(e) => resumeUpdate(e)}
                        onDelete={handleCustomDelete}
                      />
                    </div>
                  )}
                <div className="col-md-6 col-12 col-sm-12 mb-1">
                  <div className="d-flex align-items-center mb-2 mt-4 pt-1">
                    <div
                      onClick={() => setModalShow(true)}
                      className="d-flex align-items-center"
                    >
                      {resumeFields &&
                      resumeFields.data &&
                      resumeFields.data[0] &&
                      resumeFields.data[0].photo != null &&
                      resumeFields &&
                      resumeFields.data &&
                      resumeFields.data[0] &&
                      resumeFields.data[0].photo != "" ? (
                        <img
                          src={
                            resumeFields &&
                            resumeFields.data &&
                            resumeFields.data[0] &&
                            resumeFields.data[0].photo
                          }
                          alt="profilephoto"
                          className="profilephoto mr-2"
                        />
                      ) : (
                        <img
                          src="/images/user.svg"
                          alt="profilephoto"
                          className="profilephoto mr-2"
                        />
                      )}
                      <div className="upload-btn-wrapper">
                        <ResumeButton
                          padding="6px"
                          left
                          black
                          left_icon
                          src="/images/uparrow.svg"
                          alt="plus"
                          title={
                            resumeFields &&
                            resumeFields.data &&
                            resumeFields.data[0] &&
                            resumeFields.data[0].photo != "" &&
                            resumeFields &&
                            resumeFields.data &&
                            resumeFields.data[0] &&
                            resumeFields.data[0].photo != null
                              ? "Change Photo"
                              : "Upload Photo"
                          }
                        />
                        {/* <button className="btn">
                          <img
                            src="/images/uparrow.svg"
                            className="mr-2"
                            alt="download"
                          />
                          {profileImage != "" ? "Change Photo" : "Upload Photo"}
                        </button> */}
                      </div>
                    </div>
                    {resumeFields &&
                      resumeFields.data &&
                      resumeFields.data[0] &&
                      resumeFields.data[0].photo != "" && (
                        <span
                          style={{ cursor: "pointer" }}
                          className="resetimg"
                          onClick={() => resetImage(sectionId)}
                        >
                          Reset
                        </span>
                      )}
                  </div>
                </div>
                {resumeFields &&
                  resumeFields.data &&
                  resumeFields.data[0] &&
                  resumeFields.data[0] && (
                    <div className="col-md-6 col-12 col-sm-12 mb-1">
                      <EditorInput
                        sectionId={sectionId}
                        label={
                          "jobTitle".split("_")[0] == "customField"
                            ? t(`profile.custom`)
                            : t(`profile.${"jobTitle"}`)
                        }
                        value={resumeFields.data[0]["jobTitle"]}
                        name={"jobTitle"}
                        delete={
                          "jobTitle".split("_")[0] == "customField"
                            ? true
                            : "jobTitle".split("_")[0] == "custom"
                            ? true
                            : false
                        }
                        autoComplete="off"
                        className={`form-control  ${sectionId}focus${0}`}
                        onChange={(e) =>
                          resumeHandler(e, 0, "basic", sectionId)
                        }
                        onBlur={(e) => resumeUpdate(e)}
                        onDelete={handleCustomDelete}
                      />
                    </div>
                  )}

                {Object.keys(resumeFields.data[0]).map((key, index) =>
                  key == "photo"
                    ? ""
                    : key == "name"
                    ? ""
                    : key == "jobTitle"
                    ? ""
                    : key == "showFields"
                    ? ""
                    : key == "profile_image"
                    ? ""
                    : key == "job_title"
                    ? ""
                    : resumeFields &&
                      resumeFields.data &&
                      resumeFields.data[0] &&
                      resumeFields.data[0].showFields &&
                      resumeFields.data[0].showFields[key] && (
                        <div className="col-md-6 col-12 col-sm-12 mb-1">
                          <EditorInput
                            sectionId={sectionId}
                            label={
                              key.split("_")[0] == "customField"
                                ? t(`profile.custom`)
                                : t(`profile.${key}`)
                            }
                            value={resumeFields.data[0][key]}
                            name={key}
                            delete={
                              key.split("_")[0] == "customField"
                                ? true
                                : key.split("_")[0] == "custom"
                                ? true
                                : false
                            }
                            autoComplete="off"
                            className={`form-control  ${sectionId}focus${index}`}
                            onChange={(e) =>
                              resumeHandler(e, 0, "basic", sectionId)
                            }
                            onBlur={(e) => resumeUpdate(e)}
                            onDelete={handleCustomDelete}
                          />
                        </div>
                      )
                )}
              </>
            )}

            <div className="col-md-6 col-12 col-sm-12 mb-1 mt-4 pt-1">
              {!showPopup && (
                <ResumeButton
                  padding="8px"
                  width
                  left
                  left_icon
                  primary
                  src="/images/plusgreen.svg"
                  alt="plus"
                  title="Add Additional Fields"
                  onClick={additionalFieldModal}
                />
              )}
            </div>
          </div>
          {modalShow && (
            <ProfileImageModal
              show={modalShow}
              fileUploadError={fileUploadError}
              onHide={onresumeHide}
              upload={(e) => {
                fileUpload(e);
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Profile;
